import React from 'react';
import Image from 'frontastic/lib/image';
import Button from 'components/commercetools-ui/atoms/button';
import Link from 'components/commercetools-ui/atoms/link';
import Typography from 'components/commercetools-ui/atoms/typography';
import { Reference } from 'types/reference';
import dynamic from 'next/dynamic';
const Markdown = dynamic(() => import('../../organisms/markdown'));
export type ImageTextContentProps = {
  data?: any;
  index?: number;
  totalSections?: number;
};

const ImageTextContent = ({ data, index, totalSections }: React.PropsWithChildren<ImageTextContentProps>) => {
  return (
    <div
      className={`flex items-center gap-24 lg:gap-0 ${
        data?.desktop_image_alignment === 'Left' ? 'flex-col lg:flex-row' : 'lg:flex-row-reverse'
      } ${data?.mobile_image_alignment === 'Top' ? 'flex-col' : 'flex-col-reverse'}`}
    >
      <div className={`relative  w-full lg:flex-1 lg:flex-grow `}>
        <Image
          loading="lazy"
          src={data?.image?.url}
          alt={data?.image?.description}
          className={`${index === 0 && ''} ${totalSections && index === totalSections - 1 && ''} ${
            index !== 0 && totalSections && index !== totalSections - 1
              ? data?.desktop_image_alignment === 'Left'
                ? 'lg:pl-24 xl:pl-30 2xl:pl-0'
                : 'lg:pr-24 xl:pr-30 2xl:pr-0'
              : ''
          }`}
          style={{
            width: '100%',
            height: 'auto',
            maxHeight: index === 0 || (totalSections && index === totalSections - 1) ? '720px' : '640px',
            objectFit: 'cover',
          }}
        />
      </div>
      <div className="flex-1 flex-grow ">
        <div
          className={`2xl:px:80 lg:px-48 xl:px-60  ${
            index !== 0 && totalSections && index !== totalSections - 1
              ? data?.desktop_image_alignment === 'Left'
                ? 'px-24 lg:pr-24 xl:pr-30 2xl:px-0 2xl:pl-144'
                : 'px-24 lg:pl-24 xl:pl-30 2xl:px-0 2xl:pr-144'
              : 'px-24 md:px-48 2xl:pl-80 2xl:pr-144'
          }`}
        >
          <div className="">
            <Typography
              as="h1"
              className={`pb-20 text-32 font-medium leading-10 text-[#090909] ${
                index === 0
                  ? 'lg:leading-[3.25rem] xl:px-0 xl:text-32 2xl:px-0 2xl:text-48'
                  : totalSections && index === totalSections - 1
                  ? 'w-[90%] text-center md:m-auto md:w-[50%] lg:m-0 lg:w-[90%] lg:text-left lg:leading-[2.75rem] xl:m-0 2xl:m-0 2xl:text-40'
                  : 'xl:w-[70%]  xl:text-32 middleresolution:w-[60%] 2xl:w-[60%]'
              }`}
            >
              {data?.title}
            </Typography>
          </div>

            <Markdown
              className={`flex flex-col text-[1rem] font-normal text-[#333] xl:gap-12 2xl:gap-16 ${
                index === 0 || (totalSections && index === totalSections - 1)
                  ? 'leading-8 lg:px-0 2xl:text-[1.25rem]'
                  : 'leading-6'
              } ${
                index === 1 && data?.description.includes('<img')
                  ? 'w-[min(100%,47rem)] m-auto'
                  : ''
              } text-[#333333] markdown-container font-normal 
              [&>h1]:text-2xl [&>h1]:font-bold [&>h1]:text-[#333]  /* Style for <h1> */
              [&>p]:pt-12 
              ![&>figure>div>figcaption]:text-left 
              [&>p]:w-[min(100%,47rem)] 
              [&>ul]:w-[min(100%,47rem)] 
              [&>ul]:m-auto 
              [&>ol]:w-[min(100%,47rem)] 
              [&>ol]:m-auto 
              [&>figure>div>figcaption]:w-[min(100%,47rem)]  
              [&>ul>li] 
              [&>figure>div>figcaption]:m-auto 
              [&>p]:m-auto 
              [&>ul]:list-disc 
              [&>ul>li]:my-10  
              [&>ul>li>p>a]:!text-[#337ab7] 
              [&>p>a]:!text-[#337ab7] 
              [&>a]:!text-[#337ab7] 
              text-14 
              md:text-16 
              2xl:text-18`}
              markdown={data?.description}
            />

          
          {data?.ctas &&
            data?.ctas.map((cta: any) => (
              <Link
                className={` m-0 lg:px-0`}
                link={cta?.button?.href}
                key={cta?.button?.title}
                target={cta?.button?.href?.includes('https://') ? '_blank' : ''}
                rel="noopener noreferrer"
              >
                <Button
                  style={{
                    backgroundColor: cta?.button_background_color?.hex,
                    border: `1px solid ${cta?.button_border_color?.hex}`,
                    color: cta?.button_text_color?.hex,
                  }}
                  className={`${
                    index === 0 ? 'mt-32 lg:mt-0' : 'mt-32 lg:mt-48'
                  }  w-full rounded-none  py-18 shadow-sm ${
                    cta?.button_background_color?.hex?.toLowerCase() === '#ffffff'
                      ? 'hover:!border-[#F4F4F4] hover:!bg-[#F4F4F4]'
                      : 'hover:!bg-[#394A54]'
                  }  md:max-w-fit md:px-32 `}
                >
                  <Typography as="span" className=" text-16 font-medium leading-6 xl:text-14 2xl:text-16">
                    {cta?.button?.title}
                  </Typography>
                </Button>
              </Link>
            ))}
        </div>
      </div>
    </div>
  );
};
export default ImageTextContent;
